<template>
	<!-- 
		ImgInputAutoload
		V.1.0

		PARA LA INTEGRACIÓN DE IMÁGENES REQUIERE 
		EL CONTROLADOR UiController.php y UiModel.php en la API Base

		@Author Daniel Lepe 2021
	-->
	<b-row class="ui-file-image-autoupload" align-v="center">
		
		<b-col v-if="isProcessing">
			<spinner></spinner>
		</b-col>

		<b-col cols="8" v-if="!isProcessing">

			<label v-if="label != 'false'" :for="workingId">
                {{ computedLabel }}
            </label>

			<div class="check" v-if="hasBeenProcessed && allowPdf">
				<i class="fa fa-check"></i>
			</div>

			<!-- <input v-else-if="displayingInput" type="file" :id="workingId" @change="fileUpdate($event)" :disabled="readonlyAllowed" :accept="accept"/> -->
			<b-form-file v-else-if="displayingInput" :id="workingId" :disabled="readonlyAllowed" :accept="accept" @change="fileUpdate($event)" :label="computedLabel" placeholder="jpg/png..." drop-placeholder="Suélta la imágen..." />

		</b-col>

		<b-col cols="4" v-if="!allowPdf && !isProcessing" class="img-button">
			<img class="img-thumbnail responsive uploaded-img" :src="showingURI" />
			<b-button class="button-fix" variant="danger"  size="sm" v-if="!!value" @click="askIfCleansImg()">
				<i class="fa fa-times"></i>
			</b-button>
		</b-col>
	</b-row>
</template>

<script>
	import _ from "lodash";
	import moment from "moment";
	import axios from "axios";
	import swal from "sweetalert";
	
	const portaLocatedImg = "https://supereasy1.com/archivosSubidos/receta/"

	moment.locale("es");

	export default {
		data() {
			return {
				hasBeenProcessed: false,
				file: null,
				displayingInput: true,
				isProcessing: false,
				workingId: null,
			};
		},

		props: {
			setBusy: {
				type: [Function, Object],
				default: null,
			},
			setUnBusy: {
				type: [Function, Object],
				default: null,
			},
			label: {
				type: [Number, String],
				default: null,
			},
			value: {
				type: [Number, String],
				default: null,
			},
			id: {
				type: [Number, String],
				default: null,
			},
			readonly: {
				type: [Number, String, Boolean],
				default: false,
			},
			allowPdf: {
				type: [Number, String, Boolean],
				default: false,
			},
		},

		computed: {
			showingURI(){
				let reg = /^http(.+)$/
            	return (this.value == null) ? 'https://api.supereasy.mx/storage/img/render/aab9ab5b8648335f07ad079381ff04a2/3' : (reg.test(this.value)) ? this.value : (portaLocatedImg + this.value) 
			},
			storageURI() {
				return this.allowPdf ? "ui/storevault" :  "https://api.supereasy.mx/storage/upload/picture";
			},
			readonlyAllowed() {
				if (!!this.readonly) return this.readonly;
				else return null;
			},
			computedLabel() {
				return !!this.label ? this.label : "Label";
			},
			accept() {
				if (this.allowPdf) {
					return "application/pdf, image/png, image/jpeg, image/jpg";
				} else {
					return "image/png, image/jpeg, image/jpg";
				}
			},
		},

		methods: {
			async askIfCleansImg(){
				let askResponse = await swal({
					icon: 'info',
					title: '¿Seguro que deseas continuar?',
					buttons: {
						cancel: 'Cancelar',
						danger: 'Si, borrar la imágen'
					}
				})
				console.log("askResponse", askResponse)
				if(askResponse == 'danger'){
					// const response = axios.delete((this.value.replace('render', 'delete')))
					this.$emit('input', null)
				}
			},
			fileUpdate($event) {
				if ($event.srcElement.files[0])
					this.file = $event.srcElement.files[0];
				if (this.file != null && this.file.size > 6 * 1024 * 1024) {
					swal(
						"Espera un momento",
						"La imágene debe ser menor de 6 MB",
						"info"
					).then(() => {
						this.file = null;
						this.refresh();
					});
				} else if (this.file != null && this.file.size) {
					this.tryUpload();
				}
			},
			triggerModelUpdate($event) {
				this.$emit("input", $event.target.value);
			},
			tryUpload() {
				this.isProcessing = true;
				var data = new FormData();
				data.append("imagen", this.file, this.file.name);
				if (typeof this.setBusy == "function") this.setBusy();
				axios
					.post(this.storageURI, data, {
						headers: {
							accept: "application/json",
							"Content-Type": `multipart/form-data; boundary=${data._boundary}`,
						},
					})
					.then((r) => {
						console.log("r", r);
						setTimeout(()=>{
							this.isProcessing = false;
						}, 150)
						if (typeof this.setUnBusy == "function") this.setUnBusy();
						if (r.status) {
							this.hasBeenProcessed = true;
							this.$emit("input", r.data["url"]);
						}
					})
					.catch((e) => {
						this.isProcessing = false;
						if (typeof this.setUnBusy == "function") this.setUnBusy();
						alert(
							"El servidor a cerrado la conexión, por favor intenta con imágenes mas pequeñas."
						);
					});
			},
			refresh() {
				this.displayingInput = false;
				this.isProcessing = false;
				setTimeout(() => {
					this.displayingInput = true;
				}, 50);
			},
		},

		beforeMount() {
			if (!this.id) {
				this.workingId = _.uniqueId("ui-file-image-autoupload-");
			} else {
				this.workingId = this.id;
			}
		}
		
	};
</script>

<style lang="less" scoped>
.img-button {
	position: relative;
	max-width: 115px;

	.button-fix {
		// width: 100%;
		border-radius: 50%;
		position: absolute;
		bottom: -0.5em;
		right: 0.5em;
	}
	.img-thumbnail {
		width: 6em;
		height: 6em;
		object-fit: cover;
	}
}
</style>
